import { render, staticRenderFns } from "./HeroBirds.vue?vue&type=template&id=5d0b840a&scoped=true"
import script from "./HeroBirds.vue?vue&type=script&lang=js"
export * from "./HeroBirds.vue?vue&type=script&lang=js"
import style0 from "./HeroBirds.vue?vue&type=style&index=0&id=5d0b840a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b840a",
  null
  
)

export default component.exports